import {Directive, Host, Optional, Self} from '@angular/core';
import {Menu} from 'primeng/menu';
import {TieredMenu} from 'primeng/tieredmenu';

/**
 *      IMPORTANT!
 *      Both directives in this class are used as temporary workarounds for a PrimeNG bug that causes the first item of Menus and TieredMenus
 *      to be focussed when the menu is opened. The directives override essential parts of the focussing mechanism.
 *
 *      The tracked bug can be found here: https://github.com/primefaces/primeng/issues/13818
 *      The JIRA ticket for the bug can be found here: https://testfabrik.atlassian.net/browse/WMKNBN-9697
 *
 *      Remove these directives after the issue has been fixed properly
 */


@Directive({
    selector: 'p-menu[wmknbn9697bugfix]',
})
export class PMenuBugFixDirective {

    constructor(@Host() @Self() @Optional() public menu: Menu) {
        // override the focus update mechanism
        menu.changeFocusedOptionIndex = () => {};
    }
}


@Directive({
    selector: 'p-tieredMenu[wmknbn9697bugfix]',
})
export class PTieredMenuBugFixDirective {

    constructor(@Host() @Self() @Optional() public menu: TieredMenu) {
        // focusedItemInfo is a signal used to indicate which item to highlight. Override the set method of the signal to prevent items from being focussed
        menu.focusedItemInfo.set = () => {};
    }
}
